import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TAny } from "@app/lib/models/common.type";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { HearingNotice } from "../models/hearing-notice.model";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class HearingNoticeService extends BaseHttpService {
    private baseUrl: string;
    constructor(http: HttpClient, appConfig: AppConfiguration) {
        super(http, appConfig);
        this.baseUrl = this.appConfig.hostUrl;
    }

    /**
     * Search Case By case information
     * @param reqBody 
     * @param queryParams 
     * @returns 
     */

    public searchCaseDetailsHN(queryParams: TAny) {
        return this.get<IResponse<HearingNotice[]>>(
            'hearing-summons/search.htm',
            { params: { ...queryParams } }
        );
    }
    feePaymentPrint(reqBody: TAny): Observable<Blob> {
        const params = reqBody;

        const url = `${this.baseUrl}hearing-summons/view-report.htm`;
        return this.http.get(url, { params, responseType: 'blob' });
    }
    closeTask(ReqBody: TAny) {
        return this.post<IResponse<TAny>, TAny>('hearing-summons/close-hearing-notice.htm', ReqBody);
    }
}